<template>
    <m-main-layout>
        <div class="page-content-main">
            <el-table :data="dataList" default-expand-all style="width: 100%" row-key="id" :tree-props="{children: 'child'}" :indent="30" v-if="dataList.length > 0">
                <el-table-column
                        prop="name"
                        label="真是姓名">
                </el-table-column>
                <el-table-column
                        prop="nickname"
                        label="昵称">
                </el-table-column>
                <el-table-column
                        prop="mobile"
                        label="手机号">
                </el-table-column>
                <el-table-column
                        prop="state"
                        label="状态" style="font-size:12px;" width="100">
                    <template slot-scope="scope">
                        <el-tag disable-transitions v-if="scope.row.state === 1">待审核</el-tag>
                        <el-tag disable-transitions v-if="scope.row.state === 2">已通过</el-tag>
                        <el-tag disable-transitions v-if="scope.row.state === 3">已拒绝</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="create_time"
                        label="注册时间">
                    <template slot-scope="scope">
                        {{scope.row.create_time === 0 ? '—' : $moment.unix(scope.row.create_time).format('YYYY-M-D HH:mm:ss')}}
                    </template>
                </el-table-column>
                <el-table-column align="right" min-width="100">
                    <template slot-scope="scope">
                        <base-button @click.native="check(scope.row.id,1)" type="warning"  rule="/user/check" v-if="scope.row.state >= 2">反审核</base-button>
                        <base-button @click.native="check(scope.row.id,2)" type="warning"  rule="/user/check" v-if="scope.row.state === 1">同意</base-button>
                        <base-button @click.native="check(scope.row.id,3)" type="danger"  rule="/user/check" v-if="scope.row.state === 1">拒绝</base-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="text-center null-data f14 info" v-else>
                还没有数据
            </div>
            <div class="text-center padding-top-bottom-20" v-if="dataList.length > 0">
                <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :page-size="pageSize"
                        :current-page.sync="page"
                        :total="totalCount"
                        @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
    </m-main-layout>
</template>

<script>
    export default {
        name: "MemberList",
        data(){
            return{
                dataList: [],
                totalPage:0,
                totalCount:0,
                pageSize:20,
                page:1,
            }
        },
        methods:{
            getList(){
                let _this = this;
                this.dataList = [];
	            this.$http.httpPost({
		            url:'UserUp/listPage',
		            datas:{page:this.page,pageSize:this.pageSize},
		            success:(res)=>{
		            	console.log(res);
			            _this.dataList = res.list;
			            _this.totalPage = res.totalPage;
			            _this.totalCount = res.totalCount;
		            }
	            });
            },
	        pageChange(page){
		        this.page = page;
		        this.getList();
	        },
	        check(id,state) {
		        let _this = this;
		        let _text;

		        if(state === 2){
			        _text = '是否同意该申请？'
		        }else if(state === 3){
			        _text = '是否拒绝该申请？'
		        }else if(state === 1){
                _text = '是否恢复到审核中？'
            }

		        this.$confirm(_text, '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
			        this.$http.httpPost({
				        url:'UserUp/changeState',
				        datas:{id:id,state:state},
				        success:(res)=>{
					        _this.getList();
				        }
			        });
		        }).catch(() => {
		        });
	        },
        },
        mounted() {
            this.getList();
        }
    }
</script>
